var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c(_vm._f("render")(_vm.renderModel.type),{key:_vm.renderModel.id,tag:"component",attrs:{"active":_vm.currentNewsId == _vm.renderModel.id,"news":_vm.renderModel}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }